
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Resolve, Params, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { CommonService } from '@services/app.common.service';
import { Observable } from 'rxjs';



@Injectable()
export class LoginResolver implements Resolve<any> {
  constructor(public authService: AuthenticationService, private router: Router, private common: CommonService) {
    // this.route.queryParams.subscribe((params: Params) => {
    //  this.TalentCommunityId = params['TalentCommunityId'];
    // });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.authService.getAntiForgeryToken().map(data => {
      return data;
    });
  }
}
